import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import { Button, Modal, Table } from '../../index.js';
import { StateStyled, TypeStyled } from '../Templates.js';
const VersionsModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [versions, setVersions] = useState([]);
    useEffect(() => {
        props.defaultTemplate && getVersions(props.templateId);
    }, []);
    const getVersions = async (templateId) => {
        const versions = await templatesAPI.getTemplateVersions(templateId, props.ac, props.selectedLanguage);
        setVersions(versions);
    };
    return (React.createElement(Modal, { header: lang.templates.versions, onToggle: props.toggleVersionsModal },
        React.createElement(Table, null,
            React.createElement("tr", null,
                React.createElement("th", null, lang.templates.state),
                React.createElement("th", null, lang.templates.type),
                React.createElement("th", null, lang.templates.savedAt),
                React.createElement("th", null),
                React.createElement("th", null)),
            versions
                .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                .map((template) => (React.createElement("tr", { key: `${template.templateId}-${template.versionId}` },
                React.createElement("td", null,
                    React.createElement(StateStyled, { state: template.state },
                        template.state,
                        ' ')),
                React.createElement("td", null,
                    React.createElement(TypeStyled, { type: template.type },
                        template.type,
                        " ")),
                React.createElement("td", null, moment(template.createdAt).format(THEME.DATE_FORMAT_LONG)),
                React.createElement("td", null,
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => {
                            props.loadInEditor(template);
                            props.toggleVersionsModal();
                        } }, lang.templates.view))))))));
};
export default VersionsModal;
//# sourceMappingURL=VersionsModal.js.map